// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"form-control-clipboard__input___1IDSQ"};
    if(module.hot) {
      // 1775005099171
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  